// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notificationsSettings[data-v-62d3d959] {\n  padding: 5px;\n  height: 100%;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  flex: 1;\n  background-color: white;\n}\n.notificationsSettings__body[data-v-62d3d959] {\n  overflow: auto;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
